<!--新增或者修改-->
<template lang="pug">
    el-dialog(
        :title="placeId ? '修改场地' : '新建场地'"
        class="el-dialog-custom"
        top="3vh"
        width="95%"
        :visible.sync="vaisible"
        :close-on-click-modal="false"
        :append-to-body="true"
        @close="closeDialog(false)"
    )
        el-card(shadow="never")
            div.clearfix(slot="header")
                span.fontStyle 场地设置
            el-form(ref="dataForm" :model="dataForm" :rules="rules" label-suffix=":" label-width="170px")
                el-form-item(label="场地名称" prop="name")
                    el-input.width_ct(v-model="dataForm.name" @input="descInput" placeholder="请填写场地名称" maxlength="40" show-word-limit clearable)
                    font.font_later 您还可以输入
                    font.font_style {{ nameFont }}
                    font.font_color 个字！
                el-form-item(label="联系电话" prop="contactMobile")
                    el-input.sel_width_ct(v-model="dataForm.contactMobile" placeholder="请填写联系电话" maxlength="11" clearable)
                el-form-item(label="小程序最多预定天数" prop="subscribeDays")
                    el-input.sel_width_ct(v-model="dataForm.subscribeDays" placeholder="请填写小程序最多预定天数" maxlength="10" clearable)
                el-form-item(label="场地属性" prop="type")
                    el-select.sel_width_ct(v-model="dataForm.type" multiple clearable placeholder="请选择场地属性")
                        el-option(v-for="item in siteAttributesArray" :key="item.code" :label="item.name" :value="item.code")
                el-form-item(label="会员类型" prop="memberType")
                    el-select.sel_width_ct(v-model="dataForm.memberType" multiple clearable placeholder="请选择会员类型")
                        el-option(v-for="item in memberTypeArray" :key="item.key.toString()" :label="item.value.toString()" :value="item.key.toString()")
                el-form-item(label="注册会员单日单片限制" prop="registerMemberLimit")
                    el-input.sel_width_ct(v-model.number="dataForm.registerMemberLimit" @input="valitNumber($event, 'register')" placeholder='请填写注册会员单日单片限制' clearable)
                    font(style="color:#DCDFE6") &nbsp;&nbsp;小时
                el-form-item(label='初始会员单日单片限制' prop='juniorMemberLimit')
                    el-input.sel_width_ct(v-model.number='dataForm.juniorMemberLimit' @input="valitNumber($event, 'junior')" placeholder='请填写初始会员单日单片限制' clearable)
                    font(style="color:#DCDFE6") &nbsp;&nbsp;小时
                el-form-item(label='荣誉会员单日单片限制' prop='honorMemberLimit')
                    el-input.sel_width_ct(v-model.number='dataForm.honorMemberLimit' @input="valitNumber($event, 'honor')" placeholder='请填写荣誉会员单日单片限制' clearable)
                    font(style="color:#DCDFE6") &nbsp;&nbsp;小时
                el-form-item(label='价格说明' prop='priceDescription')
                    el-input.width_ct(v-model="dataForm.priceDescription" clearable type="textarea" :rows=6 placeholder="请填写价格说明")
                el-form-item(label='详细地址' prop='address')
                    el-input.width_ct(v-model="dataForm.address" clearable type="textarea" :rows=3 placeholder="请填写详细地址")
                el-form-item(label="列表页图" prop="displayImage")
                    el-input(v-model="dataForm.displayImage" v-show="false")
                    img(v-if="dataForm.displayImageUrl" :src="dataForm.displayImageUrl" class="avatar" style="width: 256px; height: 190px;" @click="openImgdailog(1)")
                    i(v-else class="el-icon-plus avatar-uploader-icon" style="width: 240px; height: 174px;" @click="openImgdailog(1)")
                    imgupload(v-if="openImg" ref="upimg" :width="256" :height="190" @uploadSuccess='doneup_lb')
                    el-alert(title="建议最小分辨率256×190,上传图片格式仅支持jpg,jpeg,png,大小不超过10M" effect='light' :closable="false" style="margin-top: 10px;")
                el-form-item(label="顺序" prop="sortNum")
                    el-input-number(v-model="dataForm.sortNum" controls-position="right" :min="0" :max="20")
        el-card(shadow="never")
            div.clearfix(slot="header")
                span.fontStyle 会员定场价格设置
            div
                el-row(style="padding-bottom: 15px;" :span="24")
                    el-col(:md="23" :sm="5")
                        el-button(type="primary" @click="addFeeTemplate(1)") 选择模板
                el-table(:data="clubMemberPriceData" border)
                    el-table-column(prop="memberTypeLabel" label="角色" align="center")
                    el-table-column(prop="reduceAmount" label="定场价格优惠" align="center")
                        template(slot-scope="scope")
                            font ￥&nbsp;&nbsp;
                            el-input-number(v-model="scope.row.reduceAmount" :precision="2" :min="-10000000" :max="0")
                            font &nbsp;&nbsp;&nbsp;&nbsp;元
        el-card(shadow="never")
            div.clearfix(slot="header")
                span.fontStyle 退款设置
            div
                el-row(style="padding-bottom: 15px;" :span="24")
                    el-col(:md="23" :sm="5")
                        el-button(type="primary" @click="addFeeTemplate(2)") 选择模板
                el-row
                    el-form
                        el-col(:span="8")
                            el-form-item(label="距比赛开始≤" label-width="auto")
                                el-input-number(v-model="ctRefundParmas.hours" :precision="0" :min="0" :max="100000000" :step="1")
                                font &nbsp;&nbsp;&nbsp;小时
                        el-col(:span="8")
                            el-form-item(label="退款比例:")
                                el-input-number(v-model="ctRefundParmas.rate" :min="0" :max="100")
                                font &nbsp;&nbsp;&nbsp;%
                    el-col(:span="8")
                        div(style="float: right;")
                            el-button(type="primary" @click="ctRefundOpr('add')") 添 加
                            el-button(type="danger" @click="ctRefundOpr('delete')") 删 除
                el-table(:data="refundData" border @selection-change="selectionRefoundHandle")
                    el-table-column(type="selection" align="center" width="50")
                    el-table-column(type="index" label="序号" align="center" width="50")
                    el-table-column(prop="hours" label="距比赛开始时间/小时（含）" align="center")
                    el-table-column(prop="rate" label="退款比例/%" align="center")
        span.dialog-footer(slot="footer")
            el-button(type="primary" @click="confirmAddOrUpdate") 确 定
            el-button(@click="closeDialog(false)") 取 消
        <!-- 选择模板通用组件 -->
        addFeeTemplate(v-if="addFeeTemplateVisible" ref="addFeeTemplate" @chooseTemplate="chooseTemplate")
</template>

<script>
import addFeeTemplate from '../operation/fee/add-fee-template.vue'

export default {
    name: 'AddOrUpdate',
    components: {
        addFeeTemplate
    },
    props: {
        vaisible: {
            type: Boolean
        },
        placeId: {
            type: String,
            default: ''
        },
        memberTypeArray: {
            type: Array,
            default: () => []
        },
        siteAttributesArray: {
            type: Array,
            default: () => []
        }
    },
    created () {
        // 获取开始时间
        this.startHour()
        // 修改操作,初始化操作
        if (this.placeId) {
            // 获取约场地详情
            this.getPlaceDetailData()
            // 获取约场地会员价格列表
            this.getPlaceClubUserData()
            // 获取约场地退款设置列表
            this.getPlaceRefoundsData()
        }
    },
    data () {
        return {
            mintime: '',
            delCtRefundDisabled: false,
            aaa: [{ name: '开发测试' }],
            ctRefund: {},
            rules: {
                name: [{ required: true, message: '场地名称不能为空!', trigger: 'change' }],
                subscribeDays: [{ required: true, message: '小程序最多预定天数不能为空!', trigger: 'blur' }, {
                    validator: (rule, value, callback) => {
                        if (!/^[1-9]\d*$/.test(value)) {
                            callback(new Error('小程序最多预定天数输入有误!'))
                        } else {
                            callback()
                        }
                    },
                    trigger: 'blur'
                }],
                type: [{ required: true, message: '场地属性不能为空!', trigger: 'blur' }],
                memberType: [{ required: true, message: '会员类型不能为空!', trigger: 'blur' }],
                priceDescription: [{ required: true, message: '价格说明不可为空!', trigger: 'change' }],
                address: [{ required: true, message: '详细地址不可为空!', trigger: 'change' }],
                sortNum: [{ required: true, message: '顺序不可为空!', trigger: 'blur' }],
                honorMemberLimit: [{ required: true, message: '荣誉会员单日单片限制不可为空!', trigger: 'change' }],
                juniorMemberLimit: [{ required: true, message: '初始会员单日单片限制不可为空!', trigger: 'change' }],
                registerMemberLimit: [{ required: true, message: '注册会员单日单片限制不可为空!', trigger: 'change' }]
            },
            // 界面参数
            dataForm: {
                name: '',
                contactMobile: '',
                subscribeDays: null,
                type: '',
                memberType: '',
                priceDescription: '',
                honorMemberLimit: 4,
                registerMemberLimit: 2,
                juniorMemberLimit: 4,
                displayImage: '',
                sortNum: 0,
                displayImageUrl: ''
            },
            openImg: false,
            nameFont: 40,
            chooseRefoundData: [], // 选择的退款数据
            clubMemberPriceData: [
                { id: null, memberTypeLabel: '注册会员', memberType: 1, reduceAmount: 0.0 },
                { id: null, memberTypeLabel: '初始会员', memberType: 2, reduceAmount: 0.0 },
                { id: null, memberTypeLabel: '荣誉会员', memberType: 3, reduceAmount: 0.0 }
            ], // 会员定场价格设置数据
            addFeeTemplateVisible: false,
            ctRefundParmas: {
                hours: 0,
                rate: 0,
                index: ''
            }, // 退款参数
            refundData: [], // 退款数据集合
        }
    },
    methods: {
        startHour () {
            this.$http({
                url: this.$http.adornUrl(`/bp-book-places/startHour`),
                method: 'get'
            }).then((data) => {
                const time = data.data * 1 - 1
                if (time < 10) {
                    this.mintime = '0' + time + ':' + '00'
                } else {
                    this.mintime = time + ':' + '00'
                }
            })
        },
        valitNumber (event, type) {
            if (parseFloat(event) < 0 || parseFloat(event) > 24) {
                switch (type) {
                    case 'register':
                        this.dataForm.registerMemberLimit = 0
                        break
                    case 'junior':
                        this.dataForm.juniorMemberLimit = 0
                        break
                    case 'honor':
                        this.dataForm.honorMemberLimit = 0
                        break
                }
            }
        },
        // 强制渲染
        renderForce () {
            this.$forceUpdate()
        },
        // 新增或者修改确认操作
        confirmAddOrUpdate () {
            this.$refs['dataForm'].validate(valid => {
                if (valid) {
                    if (this.clubMemberPriceData.length < 1 || this.refundData.length < 1) {
                        return this.$message.warning('会员价格设置、退款设置数据不可为空')
                    }
                    if (this.refundData.some(ele => { return ele.hours <= 0 })) {
                        return this.$message.warning('退款价格设置,距比赛开始时间不可为0,请删除重新添加')
                    }
                    const databody = { ...this.dataForm }
                    databody.memberPriceList = this.clubMemberPriceData
                    databody.businessRefundList = this.refundData
                    // 数据需要处理(将数组拼接成字符串)
                    databody.type = databody.type.join()
                    databody.memberType = databody.memberType.join()
                    let apiUrl = ''
                    let apiMethod = ''
                    if (this.placeId) {
                        // 修改操作
                        apiUrl = `/bp-book-places/${this.placeId}`
                        apiMethod = 'put'
                    } else {
                        // 新增操作
                        apiUrl = '/bp-book-places'
                        apiMethod = 'post'
                    }
                    // http
                    this.$http({
                        url: this.$http.adornUrl(`${apiUrl}`),
                        method: `${apiMethod}`,
                        data: databody
                    })
                    .then(data => {
                        if (data && data.code === 0) {
                            this.$message.success('操作成功')
                            this.closeDialog(false)
                            this.$emit('refreshDataList')
                        }
                    })
                    .catch(e => {})
                }
            })
        },
        // 打开模板
        addFeeTemplate (type) {
            this.addFeeTemplateVisible = true
            this.$nextTick(() => {
                this.$refs.addFeeTemplate.init(type)
            })
        },
        // 退款设置操作按钮
        ctRefundOpr (oprType) {
            if (oprType === 'add') {
                if (
                    this.ctRefundParmas.hours === undefined ||
                    this.ctRefundParmas.rate === undefined
                ) {
                    return this.$message.warning('请将退款设置数据填写完整')
                }
                this.ctRefundParmas.index = new Date().getTime() // 用来标记删除用的
                let params = { ...this.ctRefundParmas }
                this.refundData.push(params)
                this.ctRefundParmas = {
                    hours: 0,
                    rate: 0,
                    index: ''
                }
            } else {
                if (
                    this.chooseRefoundData &&
                    this.chooseRefoundData.length === 0
                ) {
                    return this.$message.warning('请先选择需要删除的退款数据')
                }
                this.chooseRefoundData.forEach(ele => {
                    this.refundData = this.refundData.filter(item => {
                            return item.index !== ele.index
                        }
                    )
                })
            }
        },
        selectionRefoundHandle (val) {
            this.chooseRefoundData = val
        },
        descInput () {
            // 判断还能写多少字符得
            let len = 40 - this.dataForm.name.length
            this.nameFont = len
        },
        closeDialog (val) {
            this.$emit('update:vaisible', val)
        },
        // 选择模板后的动作
        chooseTemplate (list, type) {
            this.addFeeTemplateVisible = false
            if (type === 1) {
                // 会员定场价格设置
                this.clubMemberPriceData = []
                list.forEach(e => {
                    if (e.typeRole === 1 && e.typeVal === 1) {
                        let da = {
                            id: null,
                            memberTypeLabel: '注册会员',
                            memberType: 1,
                            reduceAmount: e.value
                        }
                        this.clubMemberPriceData.push(da)
                    } else if (e.typeRole === 1 && e.typeVal === 2) {
                        let da = {
                            id: null,
                            memberTypeLabel: '初始会员',
                            memberType: 2,
                            reduceAmount: e.value
                        }
                        this.clubMemberPriceData.push(da)
                    } else if (e.typeRole === 1 && e.typeVal === 3) {
                        let da = {
                            id: null,
                            memberTypeLabel: '荣誉会员',
                            memberType: 3,
                            reduceAmount: e.value
                        }
                        this.clubMemberPriceData.push(da)
                    }
                })
            }
            if (type === 2) {
                // 退款设置
                this.refundData = [] // 待考虑要不要清空,还是追加
                let index = 1
                for (let i of list) {
                    this.refundData.push({
                        index: index++,
                        hours: i.typeVal,
                        rate: i.value
                    })
                }
            }
        },
        // 获取场地详情接口
        getPlaceDetailData () {
            this.$http({
                url: this.$http.adornUrl(`/bp-book-places/${this.placeId}`),
                method: 'get',
                params: this.$http.adornParams({ id: this.placeId })
            })
            .then(data => {
                if (data && data.code === 0) {
                    this.dataForm = data.data
                    this.dataForm.type = this.dataForm.type.split(',')
                    this.dataForm.memberType = this.dataForm.memberType.split(',')
                }
            })
        },
        // 获取约场地会员价格列表
        getPlaceClubUserData () {
            this.$http({
                url: this.$http.adornUrl(`/bp-book-places/member-price-list/${this.placeId}`),
                method: 'get',
                params: this.$http.adornParams({ id: this.placeId })
            })
            .then(data => {
                if (data && data.code === 0) {
                    this.clubMemberPriceData = data.data
                    // 排序
                    this.clubMemberPriceData = this.clubMemberPriceData.sort((pre, next) => {
                            return (
                                pre.memberType - next.memberType
                            )
                        }
                    )
                }
            })
        },
        // 获取约场地退款设置列表
        getPlaceRefoundsData () {
            this.$http({
                url: this.$http.adornUrl(`/bp-book-places/refund-percent-list/${this.placeId}`),
                method: 'get',
                params: this.$http.adornParams({ id: this.placeId })
            })
            .then(data => {
                if (data && data.code === 0) {
                    let no = 1
                    this.refundData = data.data.map(ele => {
                        ele.index = no++
                        return ele
                    })
                }
            })
        },
        //打开图片剪裁框
        openImgdailog (type) {
            this.openImg = true
            this.$nextTick(() => {
                if (type === 1) {
                    this.$refs.upimg.init('ctLevel') //传入图片类型参数
                }
            })
        },
        //剪裁完成的回显 列表页
        doneup_lb (val, url) {
            this.dataForm.displayImage = val
            this.dataForm.displayImageUrl = url
            this.openImg = false
        }
    }
}
</script>

<style scoped>
.el-dialog-custom {
    overflow: hidden !important;
}
.el-dialog-custom /deep/ .el-dialog__body {
    height: 73vh;
    overflow: auto;
}
.el-dialog-custom /deep/ .el-dialog__footer {
    border-top: 1px solid #E9E9E9;
}

.son-container {
    flex-grow: 1;
    flex: 1;
    display: flex;
    margin-bottom: 20px;
}

.container {
    display: flex;
    justify-content: space-between;
    overflow: auto;
}

.fontStyle {
    font-weight: bold;
    font-size: 18px;
}

.width_ct {
    width: 50%;
}

.sel_width_ct,
.input_width_ct {
    width: 20% !important;
}

.input_title {
    width: 80px;
    flex-shrink: 0;
}

.buttonStyle {
    width: 250px;
    text-align: center;
    flex-shrink: 0;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #ccc;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
